/*
 * author: wendux
 * email: 824783146@qq.com
 * source code: https://github.com/wendux/Ajax-hook
 **/
export {hook, unHook}from "./src/xhr-hook"
export {proxy, unProxy} from "./src/xhr-proxy"

